/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELAttributeValue,
  OTELAttributeValue$Outbound,
  OTELAttributeValue$outboundSchema,
} from "./otelattributevalue.js";

/**
 * OTEL log attribute with key and typed value
 */
export type OTELAttribute = {
  /**
   * Attribute key
   */
  key: string;
  /**
   * OTEL attribute value - any of the OTLP/JSON value kinds
   */
  value?: OTELAttributeValue | undefined;
};

/** @internal */
export type OTELAttribute$Outbound = {
  key: string;
  value?: OTELAttributeValue$Outbound | undefined;
};

/** @internal */
export const OTELAttribute$outboundSchema: z.ZodMiniType<
  OTELAttribute$Outbound,
  OTELAttribute
> = z.object({
  key: z.string(),
  value: z.optional(OTELAttributeValue$outboundSchema),
});

export function otelAttributeToJSON(otelAttribute: OTELAttribute): string {
  return JSON.stringify(OTELAttribute$outboundSchema.parse(otelAttribute));
}
